export default "__VITE_ASSET__5751150f__"